import { render, staticRenderFns } from "./UploadFilesForm.vue?vue&type=template&id=78b7cdba&scoped=true&"
import script from "./UploadFilesForm.vue?vue&type=script&lang=js&"
export * from "./UploadFilesForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadFilesForm.vue?vue&type=style&index=0&id=78b7cdba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b7cdba",
  null
  
)

export default component.exports